
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/users/forgot_password",
      function () {
        return require("private-next-pages/users/forgot_password.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/users/forgot_password"])
      });
    }
  